/**
 * Records a `$click` analytics event for the control that received `event`. The page's click tracker counts only
 * clicks on links, so a control drawn as a button reports its own.
 *
 * @param {Event} event
 */
export function trackControlClick(event) {
  window.Sparkle?.Analytics?.trackElementClick?.(event.currentTarget);
}
